"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: quiz/post-survey-action.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fquiz%2Fpost-survey-action.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.postSurveyActionToJSON = exports.postSurveyActionFromJSON = exports.PostSurveyAction = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.quiz.proto';
var PostSurveyAction;
(function (PostSurveyAction) {
    PostSurveyAction["INVALID_POST_SURVEY_ACTION"] = "INVALID_POST_SURVEY_ACTION";
    PostSurveyAction["NOT_HIRED"] = "NOT_HIRED";
    /**
     * ASK_EMPLOYER_ABOUT_DIRECT_DEPOSIT - Hired, not paid by DD, ask employer to pay by DD.
     */
    PostSurveyAction["ASK_EMPLOYER_ABOUT_DIRECT_DEPOSIT"] = "ASK_EMPLOYER_ABOUT_DIRECT_DEPOSIT";
    /**
     * UPSELL_DIRECT_DEPOSIT - Hired, not paid by DD, employer supports DD, get paid by DD instead.
     */
    PostSurveyAction["UPSELL_DIRECT_DEPOSIT"] = "UPSELL_DIRECT_DEPOSIT";
    /**
     * SWITCH_DIRECT_DEPOSIT_TO_STEP - Hired, paid by DD, set up DD on Step.
     */
    PostSurveyAction["SWITCH_DIRECT_DEPOSIT_TO_STEP"] = "SWITCH_DIRECT_DEPOSIT_TO_STEP";
    PostSurveyAction["UNRECOGNIZED"] = "UNRECOGNIZED";
})(PostSurveyAction || (exports.PostSurveyAction = PostSurveyAction = {}));
function postSurveyActionFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_POST_SURVEY_ACTION':
            return PostSurveyAction.INVALID_POST_SURVEY_ACTION;
        case 1:
        case 'NOT_HIRED':
            return PostSurveyAction.NOT_HIRED;
        case 2:
        case 'ASK_EMPLOYER_ABOUT_DIRECT_DEPOSIT':
            return PostSurveyAction.ASK_EMPLOYER_ABOUT_DIRECT_DEPOSIT;
        case 3:
        case 'UPSELL_DIRECT_DEPOSIT':
            return PostSurveyAction.UPSELL_DIRECT_DEPOSIT;
        case 4:
        case 'SWITCH_DIRECT_DEPOSIT_TO_STEP':
            return PostSurveyAction.SWITCH_DIRECT_DEPOSIT_TO_STEP;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return PostSurveyAction.UNRECOGNIZED;
    }
}
exports.postSurveyActionFromJSON = postSurveyActionFromJSON;
function postSurveyActionToJSON(object) {
    switch (object) {
        case PostSurveyAction.INVALID_POST_SURVEY_ACTION:
            return 'INVALID_POST_SURVEY_ACTION';
        case PostSurveyAction.NOT_HIRED:
            return 'NOT_HIRED';
        case PostSurveyAction.ASK_EMPLOYER_ABOUT_DIRECT_DEPOSIT:
            return 'ASK_EMPLOYER_ABOUT_DIRECT_DEPOSIT';
        case PostSurveyAction.UPSELL_DIRECT_DEPOSIT:
            return 'UPSELL_DIRECT_DEPOSIT';
        case PostSurveyAction.SWITCH_DIRECT_DEPOSIT_TO_STEP:
            return 'SWITCH_DIRECT_DEPOSIT_TO_STEP';
        case PostSurveyAction.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.postSurveyActionToJSON = postSurveyActionToJSON;
//# sourceMappingURL=post-survey-action.js.map